import styles from './ArticleFooter.module.scss'
import { socials } from 'constants/constants'
import { handleScrollToTop } from 'utils/helpers'
import { useTranslation } from 'next-i18next/pages'
import { Icon } from '@boltenergy-be/design-system'

const ArticleFooter = () => {
  // i18n
  const { t } = useTranslation(['blog'])

  return (
    <section className={styles.footer}>
      <div className={styles['social-plug']}>
        {t('footer.followOn')}{' '}
        <a href={socials.facebook} target="_blank" rel="noopener noreferrer">
          Facebook
        </a>{' '}
        {t('footer.and')}{' '}
        <a href={socials.instagram} target="_blank" rel="noopener noreferrer">
          Instagram
        </a>
      </div>
      <button className={styles['scroll-to-top']} onClick={() => handleScrollToTop()}>
        <span className={styles['icon-container']}>
          <Icon name="chevronUp" />
        </span>
        {t('footer.toTop')}
      </button>
    </section>
  )
}

export default ArticleFooter
